import api from '~/lib/api';
import {
  all, call, getContext, takeEvery,
} from 'redux-saga/effects';

// Helper function to dispatch an action or commit a mutation
function* dispatchAction(action) {
  const store = yield getContext('store');
  if (store._actions && store._actions[action.type]) {
    // It's an action, wait for it to complete
    yield call([store, store.dispatch], action);
  } else {
    // It's a mutation, commit it synchronously
    store.commit(action);
  }
}

function getEffects(list, payload) {
  if (list && list.length) {
    return list.map((type) => {
      let action;
      if (typeof type === 'string') {
        action = {
          type,
          payload,
        };
      } else {
        action = {
          ...type,
          ...payload,
        };
      }
      return call(dispatchAction, action);
    });
  }
  return [];
}

export function* apiFetch(action) {
  const { promise = {} } = action.payload;
  const { resolve = null, reject = null } = promise;

  // Handle onStart effects
  yield all(
    getEffects(action.payload.onStart, {
      meta: action.payload,
    }),
  );

  try {
    const response = yield call(api, action.payload); // Ensure api call is wrapped with call

    // Handle onSuccess effects
    yield all(
      getEffects(
        action.payload.onSuccess,
        {
          ...response,
          meta: action.payload,
        },
      ),
    );

    if (resolve !== null) {
      resolve(response.data);
    }
  } catch (error) {
    // Handle onError effects
    yield all(
      getEffects(
        action.payload.onError,
        {
          ...error,
          meta: action.payload,
        },
      ),
    );

    if (reject !== null) {
      reject(error.response);
    }
  }

  // Handle onFinish effects
  yield all(
    getEffects(action.payload.onFinish, {
      meta: action.payload,
    }),
  );

  if (typeof action.payload.onFinish === 'function') {
    action.payload.onFinish();
  }
}

export function* apiFetchWatch() {
  yield takeEvery('api/fetch', apiFetch);
}

export default apiFetchWatch;
